import { DOMAIN } from './Dashboard.constants';
import get from 'lodash/get';

/**
 * Plain accessors for the dashboard slice, kept separate from
 * Dashboard.selectors.
 *
 * The permission-filtered selectors in that module need the REPORTS/TODOS
 * widget registry from dashboard/constants, which imports every dashboard
 * component - so anything importing Dashboard.selectors transitively pulls in
 * the components and forms a cycle with them. Consumers that only need slice
 * state should depend on this leaf instead.
 */
export const getStore = state => get(state, DOMAIN) || {};

export const getData = state => getStore(state).data || {};
export const getError = state => getStore(state).error;
export const getPreferences = state => getStore(state).preferences || {};
export const getSelectedDomain = state => getPreferences(state).selectedDomain ?? null;
export const isLoading = state => getStore(state).loading;
